import FamilyTypeOptions from 'app/components/Hotels/FamilyTypeOptions';
import { RefObject } from 'react';
import { createPortal } from 'react-dom';

type FamilyTypeOptionsModalProps = {
	openedInput?: string;
	portalRef: RefObject<HTMLDivElement>;
	postfix?: string;
};

const FamilyTypeOptionsModal = ({ openedInput, portalRef, postfix }: FamilyTypeOptionsModalProps) => {
	const isOpen =
		openedInput === `family-type-options${postfix}` || openedInput === `mobile-select-box${postfix}`;

	if (!portalRef.current || !isOpen) {
		return null;
	}

	return createPortal(<FamilyTypeOptions postfix={postfix} />, portalRef.current);
};

export default FamilyTypeOptionsModal;
